module.exports = __webpack_public_path__ + "assets/img/system.4a3b885b.svg";